export default "__VITE_ASSET__VfyANFS7__"